import { aiResponseActions } from './aiResponse';
import { feedbackActions } from './feedback';
import { resolutionActions } from './resolution';
import { searchActions } from './search';
import { suggestionActions } from './suggestions';
export const elevioActions = {
    feedback: feedbackActions,
    resolution: resolutionActions,
    suggestions: suggestionActions,
    search: searchActions,
    aiResponse: aiResponseActions,
};
